// src/components/users/Users.jsx
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Plus } from 'lucide-react';
import { UserList } from './UserList';
import { UserProfile } from './UserProfile';

export const Users = () => {
  const { user } = useAuth();
  const [showCreateUser, setShowCreateUser] = useState(false);

  // Allow admins and receptionists to create users/register clients
  const canCreateUsers = user.role === 'admin' || user.role === 'receptionist';

  return (
    <div className="p-6">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Users</h1>
        {canCreateUsers && (
          <button
            onClick={() => setShowCreateUser(true)}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            <Plus className="h-5 w-5 mr-2" />
            {user.role === 'receptionist' ? 'Register Client' : 'Create User'}
          </button>
        )}
      </div>

      {/* Main content */}
      <UserList />

      {/* Create User Modal */}
      {showCreateUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white dark:bg-slate-800 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <UserProfile
              isCreating={true}
              onComplete={() => setShowCreateUser(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};
